import {
  FieldValues,
  UseFormReturn,
} from "@endya-conformite/ui-kit/src/lya/react-hook-form";
import { Form, SubmitHandler, FormGrid } from "@endya-conformite/ui-kit";
import { ReactElement, ReactNode, useState } from "react";
import { useOnce } from "@src/hooks/useOnce";
import { ReadonlyFieldSet } from "./ReadonlyFieldSet";

type FormParcoursConformiteProps<TFieldValues extends FieldValues> = {
  children: ReactNode;
  formConfig: UseFormReturn<TFieldValues>;
  onSubmit: SubmitHandler<TFieldValues>;
  renderActions: (
    submitIfValid: () => Promise<void>,
    isSubmitting: boolean
  ) => ReactElement;
  className?: string;
  id?: string;
  validateOnMount?: boolean;
  readonly?: boolean;
};

export function FormParcoursConformite<TFieldValues extends FieldValues>({
  children,
  formConfig,
  onSubmit,
  renderActions,
  className,
  id,
  readonly,
  validateOnMount = false,
}: FormParcoursConformiteProps<TFieldValues>) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitAnyway = async (): Promise<void> => {
    // submit ignoring validations
    setIsSubmitting(true);
    try {
      await onSubmit(formConfig.getValues());
    } finally {
      setIsSubmitting(false);
    }
  };

  useOnce(() => {
    if (readonly || validateOnMount) {
      formConfig.trigger().catch(console.error);
    }
  });

  return (
    <Form
      formConfig={formConfig}
      onSubmit={onSubmit}
      className={className}
      id={id}
    >
      <FormGrid disableHorizontalGutter>
        <ReadonlyFieldSet readonly={readonly}>{children}</ReadonlyFieldSet>
        {renderActions(
          readonly ? () => Promise.resolve() : submitAnyway,
          isSubmitting
        )}
      </FormGrid>
    </Form>
  );
}
